<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-body">
          <div class="content-wrapper">
            <img
              class="content"
              :src="src.imageUrl"
              @click="linkTo(src.imageLink)"
            />
          </div>
          <div class="btn-wrap">
            <div class="checkbox">
              <input
                type="checkbox"
                :checked="checkNoMore"
                @click="checkNoMore = !checkNoMore"
                id="check"
              />
              <label for="check">
                <span style="margin-left: 8px">오늘 보지 않기</span>
              </label>
            </div>
            <button @click="closeModal">닫기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- <style src="./../ModalCommon.css" scoped></style> -->
<style src="./layout.css" scoped></style>

<script>
/* eslint-disable */
export default {
  name: "noticeTemplate",
  props: ["content", "src"],
  data() {
    return {
      checkNoMore: false
    };
  },
  methods: {
    selectAddress() {},
    closeModal() {
      if (this.checkNoMore) {
        this.$emit("noMore");
      }
      this.$emit("close");
    },
    // noMore() {},
    linkTo(url) {
      if (!url) return;
      window.open(url, "_blank");
    }
  },
  created() {
    document.body.classList.add("modal-open");
  },
  destroyed() {
    document.body.classList.remove("modal-open");
  },
  computed: {}
};

export const noticeConfig = () => {};
</script>
<style scoped>
.modal-content {
  line-height: 2;
}
</style>
